import { queryOptions } from '@tanstack/react-query'
import { Pagination } from '@thinknimble/tn-models'
import { botTokenApi } from './api'
import { BotTokenFilter } from './models'

export const botTokenQueries = {
  all: () => ['bot-tokens'],
  list: ({
    filters,
    pagination,
  }: {
    filters?: Partial<BotTokenFilter>
    pagination?: Pagination
  }) => {
    return queryOptions({
      queryKey: [...botTokenQueries.all(), { filters, pagination }],
      queryFn: () => botTokenApi.list({ filters, pagination }),
      enabled: Boolean(filters?.organization),
    })
  },
}
